import React, { useEffect, useState } from "react";
import { API_ROUTES } from "../../../utils/constants";

const FilterComponent = (props) => {
  const {
    handleChange,
    handleCP,
    handleNtwk,
    handleDropDownChange,
    isAuthExpired,
    filterDatas,
    register,
    getData,
    placeholderText,
    allCPs = [],
    isLoading1,
  } = props;

  const [operatorList, setOperatorList] = useState([]);
  const [isLoadingOperators, setIsLoadingOperators] = useState(true);
  const userData = JSON.parse(localStorage.getItem("userDataFs"));

  const getOperators = async () => {
    setIsLoadingOperators(true);
    try {
      const response = await fetch(API_ROUTES.NETWORKS, {
        method: "POST",
        headers: { token: userData?.responseDetails?.token },
      });
      const responseJSON = await response.json();
      isAuthExpired(responseJSON);
      if (responseJSON.status.toString() === "200") {
        const responseData = responseJSON.data;
        setOperatorList(responseData);
        setIsLoadingOperators(false);
      }
    } catch (error) {
      console.log("Error getting data: ", error);
      setOperatorList([]);
      setIsLoadingOperators(false);
    }
  };

  useEffect(() => {
    getOperators();
  }, []);

  return (
    <div className="row mb-10">
      <div className="offset-xl-3 col-xl-2 offset-lg-2 col-lg-2 offset-sm-1 col-sm-2 col-6 pr-xl-5 pr-lg-5 pr-md-5 pr-sm-0 pl-xs-15 pr-xs-5">
        <select className="filter_text" onChange={handleCP}>
          <option value="">-Select CP-</option>
          {allCPs &&
            allCPs.length > 0 &&
            allCPs.map((cp) => {
              return (
                <option key={cp.id} value={cp.id}>
                  {cp.name}
                </option>
              );
            })}
        </select>
      </div>
      <div className="col-xl-2 col-lg-2 col-sm-2 col-6 pr-xl-5 pr-lg-5 pr-md-5 pr-sm-0 pl-xs-15 pr-xs-5 mt-xs-5">
        <select className="filter_text" onChange={handleNtwk}>
          <option value="">-Select Network-</option>
          {operatorList.length !== 0 &&
            operatorList.map((operator) => {
              return (
                <option key={operator.id} value={operator.id}>
                  {operator.network}
                </option>
              );
            })}
        </select>
      </div>
      <div className="col-xl-1 col-lg-2 col-sm-2 col-6 pl-lg-5 pr-lg-10 pl-md-5 pr-md-5 pl-sm-10 pr-sm-5 pl-xs-5 pr-xs-15 mt-xs-5">
        <select
          className="filter_text1"
          onChange={handleDropDownChange}
          {...register("filter_text1")}
        >
          <option value="">-Select One-</option>
          <option value="service_id">Service ID</option>
          <option value="service_name">Service Name</option>
          <option value="product_name">Product Name</option>
          <option value="product_id">Product Id</option>
        </select>
      </div>
      <div className="offset-xl-0 col-xl-2 offset-lg-0 col-lg-2 pl-lg-0 offset-sm-0 col-sm-2 offset-0 pl-sm-0 pl-md-5 pr-sm-10 pl-xs-15 mt-xs-5 pr-xs-15">
        <input
          className="filter_text filter_box"
          onChange={handleChange}
          placeholder={placeholderText}
        />
      </div>
      <div className="col-xl-1 col-lg-1 col-sm-1 col-3 pl-lg-0 pl-md-5 pl-sm-5 pl-xs-5 mt-xs-5">
        <button className="btn_1 btn-primary" onClick={getData} type="button">
          <i className="fa fa-search"></i>
        </button>
      </div>
    </div>
  );
};

export default FilterComponent;
